import { MessageCircle } from "lucide-react";
import { Reveal } from "./Reveal";
import { WA_SCHEDULE } from "@/lib/constants";

export const SchedulingCTA = () => (
  <section id="agendamento" data-testid="scheduling-section" className="bg-white py-20 lg:py-28">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2.5rem] bg-cob-dark px-6 py-16 sm:px-12 lg:px-20 lg:py-24">
          <div className="pointer-events-none absolute -bottom-36 -right-24 h-[420px] w-[420px] rounded-full border border-cob-gold/20" />
          <div className="pointer-events-none absolute -bottom-20 -right-10 h-64 w-64 rounded-full border border-cob-gold/15" />
          <div className="pointer-events-none absolute -top-40 -left-32 h-96 w-96 rounded-full bg-cob-green/25 blur-3xl" />

          <div className="relative mx-auto max-w-3xl text-center">
            <p className="text-xs font-bold uppercase tracking-[0.28em] text-cob-gold">Agendamento</p>
            <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-[1.1] text-white">
              Pronto para cuidar da <span className="italic text-cob-gold">sua saúde?</span>
            </h2>
            <p className="mx-auto mt-5 max-w-xl text-base sm:text-lg leading-relaxed text-white/70">
              Entre em contato com a Clínica COB e agende sua consulta ou avaliação.
            </p>
            <a
              href={WA_SCHEDULE}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="scheduling-cta-whatsapp"
              className="mt-9 inline-flex items-center gap-3 rounded-full bg-cob-gold px-9 py-4.5 text-[15px] font-bold text-cob-dark transition-all duration-300 hover:bg-white hover:shadow-[0_20px_45px_-15px_rgba(213,166,66,0.6)]"
            >
              <MessageCircle className="h-5 w-5" />
              Agendar pelo WhatsApp
            </a>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
